<template>
	<div class="supInfoClass" ref='supInfoClass' >
		<RightDrawer width='40%' title="打卡详情" :visible.sync="visible" :getContainer="getContainer">
		
			<template slot="content">
				<div class="attendance-detail-wrapper">
					<!-- 1. 顶部人员信息 -->
					<div class="header-info">
						<p>驻场人员：{{details.info.username}}(ID: {{details.info.uid}})</p>
						<p>所属部门：{{details.info.department_name}}</p>
						<p>岗位职务：{{details.info.role_name}}</p>
					</div>
		
					<!-- 2. 日期与统计信息 -->
					<div class="date-stats">
						<p>日期：{{details.info.date}}</p>
						<p> {{details.info.shift_text}}· {{details.info.frequency.text}} · 应打 {{details.info.should_num}} 次
							· 已打{{details.info.done_num}} 次 · 缺卡{{details.info.lack_num}} 次 ·
							补卡{{details.info.supplement_num}} 次</p>
					</div>
		
					<!-- 3. 时间轴组件 -->
					<a-steps progress-dot direction="vertical" class="custom-steps">
						<a-step v-for="(item, index) in details.list" :key="index">
							<!-- 自定义时间轴图标 (根据状态显示不同颜色的圆点) -->
							<template #icon>
								<span class="custom-dot" :class="`dot-${item.status}`"></span>
							</template>
		
							<!-- 自定义标题 -->
							<template #title>
								<div class="step-title">
									<span class="time-text">{{ item.plan_time }}</span>
									<span :class="`arrow status_text${item.status}`">→</span>
									<span v-if="item.actual_time" class="actual-time">{{ item.actual_time }}</span>
									<span :class="`status_text${item.status}`" >
										{{item.status==3?'未打卡':item.status==1?'准时':item.status==4?'已补卡':'待打卡'}}
									</span>
									<span v-if="item.status_text&&item.status>0" 	class="status-tag" :class="`tag${item.status}`">
										{{ item.status_text }}
									</span>
									<!-- 补卡按钮 -->
									<a-button @click='get_reissuevisible(item)' v-if="item.status === 3" type="primary"
										size="small" class="makeup-btn">
										补卡 
									</a-button>
								</div>
							</template>
		
							<!-- 自定义描述内容 -->
							<template #description>
								<div class="step-content">
									<!-- 状态描述 (如剩余时间、已过时间) -->
									<!-- <p v-if="item.status_desc" :class="{'desc-alert': item.status === 'missing'}">
										{{ item.status_desc }}
									</p> -->
		
									<!-- 补卡专有信息 -->
									<template v-if="item.status === 4">
										<p>补卡时间：{{ item.supplement_time }}</p>
										<p class="reason-text">补卡原因：{{ item.remark }}</p>
										<div class="image-wrapper">
											<span>其他凭证：</span>
											<LookImages :list="[item.photo]" :is_img="true"></LookImages>
										</div>
										<p class="operator-info">操作人：{{ item.supplement_username }} |
											操作时间：{{ item.supplement_time }}</p>
									</template>
		
									<!-- 正常打卡/准时信息 -->
									<template v-else-if="item.status ===1">
										<p>打卡时间：{{ item.clock_time }}</p>
										<p>打卡地址：{{ item.location }}</p>
										<div class="image-wrapper">
											<span>现场照片：</span>
											<LookImages :list="[item.photo]" :is_img="true"></LookImages>
										</div>
										<p v-if="item.remark">打卡备注：{{ item.remark }}</p>
									</template>
								</div>
							</template>
						</a-step>
					</a-steps>
				</div>
			</template>
			
		</RightDrawer>
		
		
		<EditPop width='50%' @handleSubmit="handleSubmit" :form_data="form_data" :visible.sync="reissuevisible">
			<template slot="rule_user">
				<span>{{details.info.date}}</span>
				
			</template>
			<template slot="plan_time">
				<span>{{plan_time}}</span>
			</template>
		</EditPop>
	</div>

</template>

<script>
	import EditPop from "@/components/EditPop";
	import {
		getDayDetail,supplementClock
	} from "@/api/dispatch";
	import {
		message
	} from 'ant-design-vue';
	import RightDrawer from "@/components/RightDrawer";
	import LookImages from "@/components/LookImages";
	export default {
		components: {
			RightDrawer,
			LookImages,
			EditPop
		},
		props: {

		},
		data() {
			return {
				plan_time: '',
				reissuevisible: false,
				form_data: {
					title: '确认补卡',
					list: [{
							type: "slot",
							name: "rule_user",
							title: "日期",

						}, {
							type: "slot",
							name: "plan_time",
							title: "补卡时间",
						},
						{
							type: 'textarea',
							name: 'remark',
							title: '补卡原因',
							options: {

							},
						},
						{
							type: 'upload',
							name: 'photo',
							title: '其他凭证',
							options: {},
						},
					]
				},
				list: [{}, {}, {}],
				imgs: [{}],
				see_data:{},
				visible: false,
				details: {
					list: [],
					info: {
						frequency: {}
					}
				},
			}
		},
		methods: {
			get_reissuevisible(data) {
				this.see_data = data
				this.plan_time = data.plan_time
				this.reissuevisible = true
			},
			handleSubmit(e) {
				console.log('e',e)
				supplementClock({
					data: {
						"personnel_id": this.details.personnel_id,
						"date": this.details.date,
						"plan_time": this.plan_time,
						"remark":  e.values.remark,
						"photo": e.values.photo
					}
				}).then(res => {
					this.reissuevisible = false
					message.success(res.info);
					this.get_details(	this.details)

				})
			},
			get_details(item, index) {
				getDayDetail({
					data: {
						personnel_id: item.personnel_id,
						date: item.date.split('.').join('-')
					}
				}).then(res => {
					this.details = res.data;
					this.details.personnel_id =item.personnel_id,
					this.details.date = item.date.split('.').join('-')
					this.visible = true;
				})
			},
			getContainer(){
				return this.$refs.supInfoClass
			}
		}

	}
</script>
<style lang="less">
	.content_p {
		p {
			margin: 5px 0;
		}

		margin-bottom:20px;
	}


	.attendance-detail-wrapper {
		background: #fff;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
		color: #333;
	}

	/* 顶部信息 */
	.header-info p,
	.date-stats p {
		margin: 4px 0;
		font-size: 14px;
		color: #666;
	}

	.date-stats {
		margin-top: 16px;
		padding-top: 16px;
		border-top: 1px solid #f0f0f0;
		margin-bottom: 24px;
	}

	/* 时间轴自定义样式 */
	.custom-steps :deep(.ant-steps-item-title) {
		width: 140%;
		line-height: normal;
	}

	.custom-steps :deep(.ant-steps-item-description) {
		padding-bottom: 24px !important;
	}


	/* 时间轴标题行 */
	.step-title {
		display: flex;
		align-items: center;
		font-size: 15px;
		font-weight: 500;
		width: 100%;
		gap: 6px;
	}

	.time-text {
		color: #333;
		font-weight: bold;
	}

	.arrow {
		margin: 0 8px;
		color: #999;
	}

	.actual-time {
		color: #333;
		margin-right: 8px;
	}

	.custom-badge {
		margin-left: 8px;
	}

	.makeup-btn {
		margin-left: auto;
		/* 将补卡按钮推到最右侧 */
		border-radius: 4px;
		background-color: #4b7bec;
		/* 仿图片中的蓝色按钮 */
		border-color: #4b7bec;
	}

	/* 状态标签 */
	.status-tag {
		padding: 1px 6px;
		font-size: 12px;
		border-radius: 4px;
		font-weight: normal;
	}



	.tag3 {
		color: #cf1322;
		background: #fff1f0;
		border: 1px solid #ffa39e;
	}

	.tag2 {
		color: #d46b08;
		background: #fff7e6;
		border: 1px solid #ffd591;
	}

	.tag1 {
		color: #08979c;
		background: #e6fffb;
		border: 1px solid #87e8de;
	}

	/* 内容区域 */
	.step-content {
		font-size: 13px;
		color: #666;
		margin-top: 8px;
	}

	.step-content p {
		margin: 4px 0;
	}

	.desc-alert {
		color: #999;
	}

	.reason-text {
		color: #fa8c16;
		/* 补卡原因橙色文字 */
	}

	.operator-info {
		color: #999;
		font-size: 12px;
		margin-top: 8px !important;
	}

	.image-wrapper {
		display: flex;
		align-items: flex-start;
		margin: 8px 0;
	}

	.image-wrapper span {
		min-width: 60px;
	}

	/* 自定义时间轴圆点 */
	.custom-dot {
		display: inline-block;
		width: 10px;
		height: 10px;
		border-radius: 50%;
		position: relative;
		top: -2px;
	}

	/* 待打卡：灰色空心 */
	.dot-pending {
		border: 2px solid #d9d9d9;
		background: #fff;
	}

	/* 缺卡：红色空心 */
	.dot-missing {
		border: 2px solid #ff4d4f;
		background: #fff;
	}

	/* 补卡：橙色实心 */
	.dot-supplement {
		background: #fa8c16;
	}

	/* 准时：青色实心 */
	.dot-ontime {
		background: #13c2c2;
	}

	.tag0 {
		color: #397DEE;
	}

	.status_text0 {
		color: #397DEE;
		margin-right: 10rpx;
	}

	.status_text1 {
		color: #097264;
		margin-right: 10rpx;
	}

	.status_text2 {
		color: red;
		margin-right: 10rpx;
	}

	.status_text3 {
		color: #EF4444;
		margin-right: 10rpx;
	}

	.status_text4 {
		color: #F59E0C;
		margin-right: 10rpx;
	}

	.custom-steps  {
		width: 100%;
			.ant-steps-item-content {
				width: 300px !important;
				min-width: 250px !important;
				max-width: 100%;
			}
		
	}
</style>